import { MdContentCopy } from "react-icons/md";
import { useState } from "react";
import { MdCheck } from "react-icons/md";
import { ButtonProps } from "../common/Button";
import { Button } from "../common/Button";


export function CopyButton({text, label, ...props}: ButtonProps & {text: string}) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  return (
    <Button
      onClick={handleCopy}
      preset="custom"
      className={`cursor-pointer inline-flex items-center gap-1 text-xs font-medium text-gray-500 hover:text-gray-700 ${props.className}`}
      {...props}
    >
      {isCopied ? (
        <>
          <MdCheck size={16} className="text-green-500" />
          <span className="text-green-500">Copied!</span>
        </>
      ) : (
        <>
          <MdContentCopy size={16} />
          <span>{label || 'Copy'}</span>
        </>
      )}
    </Button>
  );
}